export default {
    unlockNow: 'Desbloquear agora!',

    lunarCycle: {
        title: 'Ciclo Lunar',
        description: '{username}, o ritmo da Lua tem um papel importante em nossos ciclos de curta duração, criando uma dinâmica pessoal mensal, semanal, diária ou até mesmo horária. Seja <strong>premium</strong> para saber tudo sobre as lunações e desbloquear outros recursos exclusivos.',
        approachText: 'Seja Premium e desbloqueie o Ciclo Lunar, além de vários outros recursos como Nodos Lunares, Biorritmo e Horóscopo Futuro'
    }
};